import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import ReactSelect from 'react-select';
import { useSearchAddress } from 'services';
import useTranslate from 'hooks/useTranslate';
import useDebounce from 'hooks/useDebounce';

export const CustomMultiSearchAddress: React.FC<any> = ({ formik }) => {
	const { translate } = useTranslate();
	const isFirstRender = useRef(true);

	// state
	const [locationQry, setLocationQry] = useState<string | null>(null);
	const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

	// hooks
	const debouncedQry = useDebounce(locationQry, 300);

	// query
	const { data: locationData = [], refetch } = useSearchAddress({
		keyword: debouncedQry,
		type: true,
	});

	useEffect(() => {
		if (debouncedQry) {
			refetch();
		}
	}, [debouncedQry]);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
		} else {
			setMenuIsOpen(locationData.length > 0);
		}
	}, [locationData]);

	const handleLocationChange = (optionValue: any) => {
		formik.setFieldValue('locations', [...formik.values.locations, optionValue]);
		if (optionValue?.cityId > 0) {
			formik.setFieldValue('cityIds', [...formik.values.cityIds, optionValue?.cityId]);
		} else if (optionValue?.stateId > 0) {
			formik.setFieldValue('stateIds', [...formik.values.stateIds, optionValue?.stateId]);
		} else if (optionValue?.countryId > 0) {
			formik.setFieldValue('countryIds', [...formik.values.countryIds, optionValue?.countryId]);
		}
		setMenuIsOpen(false);
	};

	const handleInputChange = (value: string) => {
		setLocationQry(value);
		if (value) {
			setMenuIsOpen(true);
		}
	};

	return (
		<Form.Group className="form-group">
			<ReactSelect
				isSearchable
				name="locations"
				options={locationData}
				getOptionLabel={(option: any) => option?.location}
				onChange={handleLocationChange}
				onInputChange={handleInputChange}
				value={''}
				onBlur={formik.handleBlur}
				autoFocus={false}
				placeholder={translate('PlaceHolder.cityStateCountry')}
				className="form-react-select"
				classNamePrefix="select"
				isOptionDisabled={(option: any) => {
					if (option?.cityId > 0) {
						return formik.values.locations.some((item: any) => item.cityId === option?.cityId);
					} else if (option?.stateId > 0) {
						return formik.values.locations.some((item: any) => item.stateId === option?.stateId);
					} else if (option?.countryId > 0) {
						return formik.values.locations.some(
							(item: any) => item.countryId === option?.countryId,
						);
					}
					return false;
				}}
				menuIsOpen={menuIsOpen}
				onMenuClose={() => setMenuIsOpen(false)}
			/>
		</Form.Group>
	);
};
